import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "43",
  height: "51",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.6 50.3a5.526 5.526 0 0 1-2.222-.452 5.787 5.787 0 0 1-1.806-1.215L1.6 37.664a4.94 4.94 0 0 1-1.25-3.09 5.01 5.01 0 0 1 .9-3.577 5.881 5.881 0 0 1 2.743-2.153 4.833 4.833 0 0 1 2.882-.208l5.417 1.25V7.247a6.945 6.945 0 1 1 13.89 0v11.945h1.804c.216-.004.43.044.625.139.185.092.394.185.625.277l10.278 5a4.92 4.92 0 0 1 2.465 2.466 5.58 5.58 0 0 1 .452 3.507l-2.5 15.138a5.247 5.247 0 0 1-1.945 3.3 5.606 5.606 0 0 1-3.611 1.285L16.6 50.3Z",
  fill: "#fff"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.6 50.3a5.526 5.526 0 0 1-2.222-.452 5.787 5.787 0 0 1-1.806-1.215L1.6 37.664a4.94 4.94 0 0 1-1.25-3.09 5.01 5.01 0 0 1 .9-3.577 5.881 5.881 0 0 1 2.743-2.153 4.833 4.833 0 0 1 2.882-.208l5.417 1.25V7.247a6.945 6.945 0 1 1 13.89 0v11.945h1.804c.216-.004.43.044.625.139.185.092.394.185.625.277l10.278 5a4.92 4.92 0 0 1 2.465 2.466 5.58 5.58 0 0 1 .452 3.507l-2.5 15.138a5.247 5.247 0 0 1-1.945 3.3 5.606 5.606 0 0 1-3.611 1.285L16.6 50.3Zm-.555-4.167H35.56l2.986-17.292-12.709-6.319h-3.819V7.247a2.78 2.78 0 1 0-5.556 0v27.709L5.767 32.664l-1.6 1.6 11.878 11.869Z",
  fill: "#606780"
}, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }